import * as types from './constants';

// Get Shopify Status
export const getShopifyStatusRequest = data => (
  { type: types.GET_SHOPIFY_STATUS_REQUEST, payload: data }
);

export const getShopifyStatusDone = data => (
  { type: types.GET_SHOPIFY_STATUS_DONE, payload: data }
);

export const getShopifyStatusFailed = errors => (
  { type: types.GET_SHOPIFY_STATUS_FAILED, payload: errors }
);
